import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import { getValidationSummaryLineTypes } from './helpers'
import * as Styles from './styles'

const ValidationSummaryLine = ({ count, type }) => {
  const validationSummaryLineTypes = getValidationSummaryLineTypes()
  const { t } = useTranslation()
  const line = validationSummaryLineTypes[type]
  const text = count === 1 ? line.singularText : line.pluralText

  if (!count) return null

  return (
    <Styles.Container>
      <line.Icon size={24} color={line.iconColor} />
      <Text type="bodyMRegular">{t(text, { count })}</Text>
    </Styles.Container>
  )
}

export default ValidationSummaryLine
